import React from 'react';
import tw from 'twin.macro';

export const Title = ({
  Type = 'h1',
  children,
  text = children,
  fontBlack = true,
  regular,
  marginBottom = true,
  ...restProps
}) => {
  return (
    <Type
      css={[
        tw`
      group-[.text-light]:text-light 
      group-[.text-dark]:text-dark`,
        fontBlack && tw`text-default font-black`,
        Type === 'h1' && tw`text-xl md:text-2xl uppercase`,
        Type === 'h2' && tw`text-lg md:text-xl uppercase`,
        (Type === 'h3' || regular) && tw`text-base md:text-lg uppercase`,
        Type === 'h4' && tw`text-base md:text-lg font-bold`,
        Type === 'h5' && tw`text-base md:text-base font-bold`,
        Type === 'h6' && tw`text-sm md:text-base font-bold`,
        marginBottom && tw`mb-2`,
      ]}
      {...restProps}
    >
      {text}
    </Type>
  );
};
